import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DefaultLayoutComponent } from './containers';
import { SenseSphereCallbackComponent } from './views/who/auth/sensesphere-callback.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: '/icd-10-tt06/icd10-tt06',
        pathMatch: 'full'
    },
    {
        path: 'auth/sensesphere/callback',
        component: SenseSphereCallbackComponent
    },
    {
        path: '',
        component: DefaultLayoutComponent,
        data: {
            title: 'Trang chủ'
        },
        children: [
            {
                path: 'search',
                loadChildren: () => import('./views/who/who.module').then((m) => m.SearchGlobalModule),
            },
            {
                path: 'notification',
                loadChildren: () => import('./views/who/who.module').then((m) => m.NotificationModule),
            },
            {
                path: 'dashboard',
                loadChildren: () => import('./views/who/who.module').then((m) => m.DashboardModule)
            },
            {
                path: 'tools',
                loadChildren: () => import('./views/who/who.module').then(m => m.ToolsModule),
            },
            {
                path: 'icd-10',
                loadChildren: () => import('./views/who/who.module').then((m) => m.Icd10Module),
            },
            {
                path: 'icd-10-tt06',
                loadChildren: () => import('./views/who/who.module').then((m) => m.Icd10TT06Module),
            },
            {
                path: 'icd-9',
                loadChildren: () => import('./views/who/who.module').then((m) => m.Icd9Module),
            },
            {
                path: 'icf',
                loadChildren: () => import('./views/who/who.module').then((m) => m.IcfModule),
            },
            {
                path: 'yhct',
                loadChildren: () => import('./views/who/who.module').then((m) => m.YhctModule),
            },
            {
                path: '',
                loadChildren: () => import('./views/who/who.module').then((m) => m.LoincModule),
            },
            {
                path: 'chatbot',
                loadChildren: () => import('./views/who/who.module').then((m) => m.ChatbotModule),
            },
        ]
    }
]

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'top',
            anchorScrolling: 'enabled',
            initialNavigation: 'enabledBlocking',
            onSameUrlNavigation: 'reload'
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}